import {
  GetLocationRegisterQuery,
  GetLocationSessionSummaryByIdQuery,
  GetZReportByLocationAndDateQuery,
  PaymentMethod
} from "src/graphql/quark/quark.type"
import { XOutPaymentMethodSummary, XOutReportData } from "src/modules/invoices/thermal/xout-report-receipt"
import { groupBy } from "src/shared/utils/groupBy"
import moment from "moment"

type RegisterSales = NonNullable<GetLocationSessionSummaryByIdQuery["getLocationSessionSummaryById"]>[0] | NonNullable<GetZReportByLocationAndDateQuery["getZReportByLocationAndDate"]>[0]
export const mapRegisterSalesToReceiptData = (
  registerSales: RegisterSales[] | [],
  register?: GetLocationRegisterQuery["getLocationRegister"]
): XOutReportData => {
  const groupedSales = groupBy(registerSales, (v) => v.paymentMethod)
  const salesByPaymentMethod = Object.values(PaymentMethod).reduce(
    (acc, method) => {
      //   ;(acc as any)[method] = groupedSales[method]?.[0] || {}
      const sale = groupedSales[method]?.[0]
      ;(acc as any)[method] = {
        gross: sale?.gross || 0,
        discount: sale?.discount,
        tax: sale?.tax,
        returns: sale?.returned,
        sale: sale?.netSale,
        net: sale?.netAmount,
        transactions: sale?.orderCount,
        integrationCharges: (sale as unknown as XOutPaymentMethodSummary)?.integrationCharges,
        platformFee: (sale as unknown as XOutPaymentMethodSummary)?.platformFee,
        shippingFee: (sale as unknown as XOutPaymentMethodSummary)?.shippingFee
      }
      return acc
    },
    {} as Record<PaymentMethod, XOutPaymentMethodSummary>
  )

  const total = Object.values(groupedSales).reduce(
    (acc, sales) => ({
      gross: (acc?.gross || 0) + (sales[0]?.gross || 0),
      discount: (acc?.discount || 0) + (sales[0]?.discount || 0),
      tax: (acc?.tax || 0) + (sales[0]?.tax || 0),
      returns: (acc?.returns || 0) + (sales[0]?.returned || 0),
      net: (acc?.net || 0) + (sales[0]?.netAmount || 0),
      sale: (acc?.sale || 0) + (sales[0]?.netSale || 0),
      transactions: (acc?.transactions || 0) + (sales[0]?.orderCount || 0),
      integrationCharges: (acc?.integrationCharges || 0) + ((sales[0] as unknown as XOutPaymentMethodSummary)?.integrationCharges || 0),
      platformFee: (acc?.platformFee || 0) + ((sales[0] as unknown as XOutPaymentMethodSummary)?.platformFee || 0),
      shippingFee: (acc?.shippingFee || 0) + ((sales[0] as unknown as XOutPaymentMethodSummary)?.shippingFee || 0)
    }),
    {} as XOutPaymentMethodSummary
  )

  return {
    startDate: register?.lastOpenedAt,
    endDate: register?.lastClosedAt ?? moment()?.toISOString(),
    registerName: register?.name ?? null,
    total: total,
    ...salesByPaymentMethod,
    printDate: moment()?.toISOString()
  }
}
